if ($('#app-vend-table').length) {

    function findSlug(id) {
        if (typeof vendors !== 'undefined') {
            var slug = '';
            for (var i in vendors) {
                if (vendors[i].id === id)
                    slug = vendors[i].slug;
            }
            var ur = "/vendors/" + slug;
            window.location.href = ur;
        }
    }

    $(document).ready(function () {
        var data_table_order=[0, "asc"];
        var app_vendor_table = $('#app-vend-table').DataTable({
            columns: [
                {data: 'type'},
                {data: 'name'},
                {data: 'vendor_affiliate'},
                {data: 'channel'},
                {data: 'frequency'},
                {data: 'vendor_format'},
                {data: 'website'},
                {data: 'owner'},
                {data: 'id'},

            ],
            pageLength: user_entries,
            order: data_table_order,
            "columnDefs": [
                {
                    "targets": 2,
                    "orderable": false,
                    "createdCell": function (td, cellData, rowData, row, col) {
                       if(rowData.type.indexOf('Television') !== -1)
                           $(td).html(cellData);
                       else
                           $(td).html('');
                    }
                }
                ,{
                    "targets": 8,
                    "orderable": false,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        console.log(cellData);
                        html = '<div class="row text-center">' +
                            ' <div class="btn-group" role="group"> <input  type="button"  onclick="findSlug(' + cellData + ')" value="Edit" class="btn btn-sm btn-success" > ' +

                            '</div>';
                        $(td).html(html);
                        console.log(cellData);
                    }
                }
            ],
            "createdRow": function (row, data, dataIndex) {
                $(row).attr('data-vendor-id', data.id);
            }

        });
        if (typeof vendors !== 'undefined') {
            app_vendor_table.clear();
            app_vendor_table.rows.add(vendors);
            app_vendor_table.draw();
        }
        $('#app-vend-table').on( 'length.dt', function ( e, settings, len ) {
            user_entries= len;
        });
        $('#app-vend-table').on( 'order.dt', function ( e, settings, len) {
            data_table_order=[len[0].col, ""+len[0].dir+""];
        } );


    });
}
